import { render, staticRenderFns } from "./TrxEx.vue?vue&type=template&id=a687a398"
import script from "./TrxEx.vue?vue&type=script&lang=js"
export * from "./TrxEx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports